import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  ViewChild,
  ComponentFactoryResolver,
  ViewContainerRef,
  Output,
  EventEmitter,
  Input,
  SimpleChanges,
  ElementRef,
  ViewChildren,
} from '@angular/core';

import { LhStorageService } from '@hssa-itasia/ngx-util-core';
import { AppService } from '../app.service';
import { BogTourService } from '../services/bog-tour/bog-tour.service';

@Component({
  selector: 'cvpc-haz-relates-to',
  styles: [
    `
      .thumps_up_col {
        display: flex;
        justify-content: right;
        align-items: center;
        margin-right: 10px;
      }
      .thumps_down_col {
        display: flex;
        justify-content: left;
        align-items: center;
        margin-left: 10px;
      }
      .relates_to_card {
        min-width: 135px;
        height: 125px;
        background: #ffffff;
        box-shadow: 0px 3px 6px #00000029;
        border: 1px solid #3bb4aa;
        border-radius: 6px;
        opacity: 1;
        position: relative;
        padding: 5px 5px 0px 0px;
        margin: 0 15px 0 0;
        z-index: 1;
      }
      .relates_to_icon_row {
        height: 65px;
      }
      .relatest_to_img_col {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 60px;
        }
      }
      .relates_to_label_col {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-size: 12px;
        letter-spacing: 0px;
        opacity: 1;
        height: 50px;
      }
      .relates_to_label_display_col {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-size: 15px;
        letter-spacing: 0px;
        color: #027382;
        opacity: 1;
        height: 50px;
      }
      .mainDiv {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        overflow-x: auto;
        padding-bottom: 15px;
      }
      .relates_to_label {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        position: relative;
      }
      .relates_to_label_thums_up {
        background: #00914633;
        padding: 2px;
        border-radius: 24px;
        color: #009146 !important;
        margin-top: 10px;
      }
      .relates_to_label_thums_down {
        background: #fcccd0;
        padding: 2px;
        border-radius: 24px;
        color: #f00014 !important;
        margin-top: 10px;
      }
      .thumbs_down_selected_css {
        height: 24px;
        width: 24px;
      }

      .card_selected_css {
      }
      .thumbs_up_row {
        margin-top: 5px;
        z-index: 999;
        position: relative;
      }
      .unselect_relatesTo {
        position: relative;
      }
      .thums_up_down_size {
        height: 40px;
      }
      .cc_special_icon_col {
        width: 25px;
        max-width: 25px;
        margin: 0px;
        padding: 0px;
        margin-top: 5px;
      }
      .close_icon_relates_to {
        height: 25px;
        width: 25px;
        color: #000;
      }
      .PPE_icon_col {
        max-width: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .PPE_text_col {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .title-text {
        color: #000;
        font-weight: 600;
        margin: 10px;
      }
      .my_shield_question_card {
        border-radius: 0px;
        margin: 0px !important;
        display: block;
        position: relative;
        box-shadow: none;
      }
      .check-tick {
        height: 16px;
        width: 16px;
        color: white;
        font-weight: 600;
      }
      .card-radius {
        border-radius: 4px;
        box-shadow: 0px 0px 6px #00000029;
        margin: 16px 0 0 0;
      }
      .title-blk {
        color: '#006884';
        font-size: 16px;
        width: 100%;
        margin: 0;
      }
      .iconfloatright {
        float: right;
        text-align: right;
      }
      .chevron-icon {
        font-size: 20px;
        color: #007382;
        cursor: pointer;
      }
      .check-box {
        height: 18px;
        width: 18px;
        text-align: center;
        border-radius: 4px;
        background: #007382;
      }
      .main_ques_div {
        background: #edf5f5;
        padding: 5px;
      }
      .not-appear {
        border-radius: 50%;
        border: 1px solid #d9d9d9;
        color: black;
        font-size: 10px;
        font-weight: 600;
        height: 40px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        cursor: pointer;
        text-align: center;
        line-height: 1;
      }
      .not-appear-selected {
        border-radius: 50%;
        border: 1px solid #d9d9d9;
        color: white;
        font-size: 10px;
        font-weight: 600;
        height: 40px;
        width: 40px;
        background: grey;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        cursor: pointer;
        text-align: center;
        line-height: 1;
      }

      .image-size {
        margin-left: 30%;
        padding: 4px;
      }
      .image-size-selected {
        margin-left: 30%;
        border: 1px solid grey;
        margin-right: 30%;
        padding: 4px;
      }
      .thums_up {
        height: 20px;
        width: 20px;
        padding-left: 0px;
        color: #009146;
        transition: all 0.3s ease;
      }
      .thums_down {
        height: 20px;
        width: 20px;
        padding: 0px;
        color: #f00014;
        transition: all 0.3s ease;
      }
      .thums_up_selected {
        height: 40px;
        width: 40px;
      }
      .thums_down_selected {
        height: 40px;
        width: 40px;
      }
      .n_a_col {
        background: grey;
      }
      .row_border {
        padding-top: 10px;
      }
      .row_border_label {
        padding: 10px;
      }
      .space-between {
        margin-left: 20px;
        margin-right: 10px;
        flex-shrink: 0;
        transition: all 0.3s ease;
        
        &:hover .thums_down_div {
          transform: scale(1.05);
          box-shadow: 0 2px 8px rgba(240, 0, 20, 0.3);
        }
        
        &:hover .not-appear {
          transform: scale(1.05);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        }
      }
      .thums_down_selected_div {
        border-radius: 50%;
        padding: 6px;
        background: #f000144d;
        height: 40px;
        width: 40px;
      }
      .thums_down_div {
        padding: 6px;
        border-radius: 50%;
        height: 40px;
        width: 40px;
        border: 2px solid #f000144d;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: white;
        transition: all 0.3s ease;
        cursor: pointer;
      }
      .thums_down_div_Animation {
        border-radius: 50%;
        border: 2px solid #f00014;
        height: 40px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f00014;
        transition: all 0.3s ease;
      }
      .questions_row {
        margin-top: -10px;
        width: 100%;
        margin-left: 20px;
        display: flex;
        align-items: center;
        gap: 15px;
        min-height: 50px;
      }
      .questions_row input {
        display: none;
      }
      .lottie_animation_div {
        background: #0091464d;
        border-radius: 50%;
      }
        .lottie_animation_div_down {
        background: #f000144d;
        border-radius: 50%;
      }

      .thums_up_div {
        padding: 6px;
        border-radius: 50%;
        border: 2px solid #0091464d;
        height: 40px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: white;
        transition: all 0.3s ease;
        cursor: pointer;
      }
      .thums_up_div_tickAnimation {
        border-radius: 50%;
        border: 2px solid #009146;
        height: 40px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #009146;
        transition: all 0.3s ease;
      }
      .thums_up_container {
        margin-left: 10px;
        margin-right: 10px;
        flex-shrink: 0;
        transition: all 0.3s ease;
        
        &:hover .thums_up_div {
          transform: scale(1.05);
          box-shadow: 0 2px 8px rgba(0, 145, 70, 0.3);
        }
      }
      .questions_label {
        float: left;
        margin-left: 6px;
        margin-left: 28px;
        margin-top: 0px;
        font-size: 12px;
        color: #000000;
      }
      .question_count {
        float: left;
        color: #000000;
        font-weight: 600;
        font-size: 10px;
      }
      .lottie_player {
        border-radius: 50%;
        height: 40px;
        width: 40px;
      }
      .question_border {
        border: 1px solid #007382 !important;
        margin-top: 10px;
      }
      .card_unchecked {
        filter: grayscale(1) invert(1);
        opacity: 0.5;
      }
      .card_unchecked_border {
        border: 2px solid #e0e0e0;
      }
      .click_disabled_ {
        pointer-events: none;
      }
      .mainDiv {
        display: flex;
        flex-direction: row;
        overflow-x: auto;
        scroll-behavior: smooth;
      }
    `,
  ],
  template: `
    <div class="mainDiv" #scrollContainer>
      <div
        *ngFor="let option of options; let i = index"
        #optionCards
        [ngClass]="appservice.observation_mode != 'create' ? 'click_disabled_' : ''"
      >
        <ion-card
          class="relates_to_card"
          (click)="onChange($event, option, '', 'select')"
          [ngClass]="option.card_checked ? 'card_selected_css' : 'card_unchecked_border'"
        >
          <ion-row
            class="relates_to_icon_row"
            [ngClass]="option.checked == '' ? 'card_unchecked' : ''"
          >
            <ion-col class="relatest_to_img_col">
              <img *ngIf="option.card_checked != ''" [src]="option.category_image" />
              <img *ngIf="option.card_checked == ''" [src]="option.category_inactive_image" />
            </ion-col>
            <ion-col
              class="cc_special_icon_col"
              *ngIf="option.is_critical_control && !option?.has_questionnaire"
            >
              <img src="assets/img/rapid-tour/relatest_to_icon/cc_shield.svg" />
            </ion-col>
          </ion-row>
          <ion-row [ngClass]="option.checked == '' ? 'card_unchecked' : ''">
            <ion-col class="relates_to_label_display_col">
              <!-- [ngClass]="{'relates_to_label_thums_up':option.checked == 'Checked','relates_to_label_thums_down':option.checked == 'Not Checked'}" -->
              <div class="relates_to_label">
                {{ option.label }}
              </div>
            </ion-col>
          </ion-row>
        </ion-card>
      </div>
    </div>
    <!-- <div  *ngFor="let item of selected_sub_RelatesTo">
      <ion-row  [ngClass]="{'relates_to_label_thums_up':item.checked == 'Checked','relates_to_label_thums_down':item.checked == 'Not Checked'}">
        <ion-col (click)="onChange('',item,'','select')" size="10" class="ion-align-self-center relates_to_label_col" >
          <div  class="relates_to_label">
              {{ item.label}}                    
          </div>
        </ion-col>
          <ion-col class="ion-align-self-center" size="2">
            <div (click)="onChange($event,item, '','unselect')" class="unselect_relatesTo" *ngIf="item.checked != ''">
                <ion-icon class="close_icon_relates_to" name="close-outline"></ion-icon>
            </div>
          </ion-col>
      </ion-row>
    </div> -->
    <div>
      <ion-row class="title-text">
        <!-- <ion-label> {{current_relates_to.label | translate}}</ion-label> -->
        <div>
          <!-- Your selection includes {{PUE_count}} critical controls. Select if you would like to assess them: -->
          <div *ngIf="PUE_count > 0 && !showMentalHealthText">
            Your selection includes {{ PUE_count }} critical controls. Assess any control below if
            you'd like to submit it as a critical
            <span *ngIf="vpc_fromPage == 'CVPC'"> We talk:</span>
            <span *ngIf="vpc_fromPage == 'HAZ'"> I see:</span>
          </div>
          <div *ngIf="showMentalHealthText">
            {{ 'MENTAL_HEALTH_RELATES_TO_TEXT' | translate }}
          </div>
        </div>
      </ion-row>
      <div *ngFor="let relates_to of cvpc_relates_to; let idx = index">
        <div>
          <ion-row>
            <ion-col class="PPE_icon_col">
              <img
                *ngIf="relates_to.isActive"
                [src]="relates_to.cvpc_active_image"
              />
              <img *ngIf="!relates_to.isActive" [src]="relates_to.cvpc_image" />
            </ion-col>
            <ion-col class="PPE_text_col">
              <ion-label *ngIf="relates_to.cvpc != 'Water Pollution Discharge'">{{
                relates_to.cvpc | translate
              }}</ion-label>
              <ion-label *ngIf="relates_to.cvpc == 'Water Pollution Discharge'"
                >Pollution</ion-label
              >
            </ion-col>
          </ion-row>
          <ion-card class="ion-no-margin my_shield_question_card">
            <div
              class="question_border"
              *ngFor="let question of relates_to.question; let i = index"
            >
              <ion-row class="main_ques_div" (click)="expandItem(i, relates_to)" style="cursor: pointer;">
                <ion-col size="1" class="ion-align-self-center">
                  <div class="check-box" *ngIf="question.expanded">
                    <ion-icon class="check-tick" name="checkmark-outline"></ion-icon>
                  </div>
                  <div
                    style="background:white;border-radius:4px;height:18px;width:18px;border:0.1em solid #007382;"
                    *ngIf="!question.expanded"
                  ></div>
                </ion-col>
                <ion-col class="ion-align-self-center">
                  <h3 style="color:#007382;font-size:12px;" class="title-blk">
                    {{ question.label }}
                  </h3>
                </ion-col>
                <ion-col size="1" class="ion-align-self-center iconfloatright">
                  <ion-icon class="chevron-icon" name="chevron-down-outline" *ngIf="!question.expanded"></ion-icon>
                  <ion-icon class="chevron-icon" name="chevron-up-outline" *ngIf="question.expanded"></ion-icon>
                </ion-col>
              </ion-row>
              <div *ngIf="question.expanded">
                <div *ngFor="let item of question.cvpc_question; let k = index">
                  <ion-row class="row_border_label">
                    <ion-col size="1" class="ion-align-self-center">
                      <div class="question_count">
                        <ion-label>{{ item.count }} </ion-label>
                      </div>
                    </ion-col>
                    <ion-col class="ion-text-left ion-align-self-center">
                      <div class="questions_label">
                        <ion-label> {{ item.label | translate }}</ion-label>
                      </div>
                    </ion-col>
                  </ion-row>

                  <ion-row
                    class="questions_row"
                    [ngClass]="appservice.observation_mode != 'create' ? 'click_disabled_' : ''"
                  >
                    <ion-col size="1" class="ion-align-self-center"> </ion-col>
                    <ion-col style="display:flex;" class="ion-text-left ion-align-self-center">
                      <div
                        class="thums_up_container"
                        aria-label="thums_up1_test"
                        role="thums_up1_test"
                        Accessibility-ID="thums_up1_test"
                      >
                        <div
                          class="thums_up_div"
                          *ngIf="item.defaultValue != 'Effective'"
                          (click)="updateFormValue(idx, i, k, 'Effective')"
                        >
                          <ion-icon
                            class="thums_up"
                            aria-label="thums_up2_test"
                            role="thums_up2_test"
                            Accessibility-ID="thums_up2_test"
                            src="assets/img/bog_tour/like_icon.svg"
                          ></ion-icon>
                        </div>
                        <div
                          class="thums_up_div_tickAnimation lottie_animation_div"
                          *ngIf="item.defaultValue == 'Effective'"
                        >
                          <img
                            class="thums_up_selected"
                            src="assets/img/bog_tour/Tick.gif"
                          />
                        </div>
                      </div>

                      <div
                        class="space-between"
                        (click)="updateFormValue(idx, i, k, 'Not Effective')"
                        aria-label="thums_down_test"
                        role="thums_down_test"
                        Accessibility-ID="thums_down_test"
                      >
                        <div
                          class="thums_down_div"
                          *ngIf="item.defaultValue != 'Not Effective'"
                        >
                          <ion-icon
                            class="thums_down"
                            aria-label="thums_down1_test"
                            role="thums_down1_test"
                            Accessibility-ID="thums_down1_test"
                            src="assets/img/bog_tour/thums_down.svg"
                          ></ion-icon>
                        </div>
                        <div
                          class="thums_down_div_Animation lottie_animation_div_down"
                          *ngIf="item.defaultValue == 'Not Effective'"
                        >
                          <img
                            class="thums_down_selected"
                            src="assets/img/bog_tour/thumbs_Down.gif"
                          />
                        </div>
                      </div>

                      <div class="space-between">
                        <div
                          *ngIf="item.defaultValue != 'Not Applicable'"
                          aria-label="not-appear1-test"
                          role="not-appear1-test"
                          Accessibility-ID="not-appear1-test"
                          class="not-appear"
                          (click)="updateFormValue(idx, i, k, 'Not Applicable')"
                        >
                          N/A
                        </div>
                        <div
                          *ngIf="item.defaultValue == 'Not Applicable'"
                          aria-label="not-appear2-test"
                          role="not-appear2-test"
                          Accessibility-ID="not-appear2-test"
                          class="not-appear-selected"
                          (click)="updateFormValue(idx, i, k, 'Not Applicable')"
                        >
                          N/A
                        </div>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>
              </div>
            </div>
          </ion-card>
        </div>
      </div>
    </div>
  `,
  standalone: false,
})
export class RelatesToSelectionComponent {
  @Input() options: any;
  selected_sub_RelatesTo: any = [];
  cvpc_relates_to: any = [];
  current_relates_to: any;
  // selected_risk:string="immediate_risk";
  is_critical_control: boolean = false;
  is_relates_to_selected: boolean = false;
  vpc_fromPage: string = '';
  PUE_count: any = 0;
  subscriber_cvpc: any;
  showMentalHealthText = false;
  @ViewChildren('optionCards') optionCards!: QueryList<ElementRef>;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  constructor(
    public appservice: AppService,
    public bogService: BogTourService,
    private lhStorage: LhStorageService
  ) {
    this.selected_sub_RelatesTo = this.bogService.selectedRelatesTo;
    this.vpc_fromPage = this.appservice.vpc_fromPage;
  }

  async ngOnChanges(changes: SimpleChanges) {
    //console.log("ngOnChnages",this.options);
    if (changes['options'] && this.options?.length) {
      setTimeout(() => this.autoScrollToCheckedOption(), 300);
    }
  }
  autoScrollToCheckedOption() {
    // const checkedIndex = this.options.findIndex(opt => opt.checked === 'checked');
    const checkedIndex = this.options.findIndex(
      (opt) => String(opt.checked).toLowerCase() === 'checked' || opt.checked === true
    );
    console.log('checkedIndex=', this.options);
    if (checkedIndex === -1) {
      return; // ⛔ No checked card — skip scroll
    }
    console.log('this.options=', this.options);
    const cardElement = this.optionCards.toArray()[checkedIndex]?.nativeElement;
    const containerElement = this.scrollContainer?.nativeElement;

    if (cardElement && containerElement) {
      const containerRect = containerElement.getBoundingClientRect();
      const cardRect = cardElement.getBoundingClientRect();

      const scrollLeft =
        cardElement.offsetLeft - containerElement.offsetWidth / 2 + cardElement.offsetWidth / 2;

      containerElement.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
    }
  }
  async ngOnInit() {
    // console.log("appservice.cvpc_formatted_list ::",this.appservice.cvpc_formatted_list);
    // this.appservice.riskLevelSubject.subscribe(res=>{
    //     if(res==''){
    //        this.selected_risk='immediate_risk';
    //     }else{
    //         this.selected_risk=res;
    //     }
    // });
    this.subscriber_cvpc = this.appservice.cvpc_questionSubject.subscribe((res) => {
      this.cvpc_relates_to = res;
      let count = 0;
      this.cvpc_relates_to.forEach((element) => {
        count = count + element.question.length;
      });
      this.PUE_count = count;
    });
  }
  onChange(event, option: any, checked: string, type: any) {
    if (option.has_questionnaire) {
      option.is_critical_control = true;
    }
    console.log('option=', option);
    console.log('type=', type);
    if (type == 'select') {
      option.card_checked = true;
      option.checked = 'Checked';
      // if(this.selected_risk =="medium_risk" || this.selected_risk =="immediate_risk"){
      //     option.checked = 'Not Checked';
      // }
      // else{
      //     option.checked = 'Checked';
      // }
    } else {
      option.card_checked = false;
      option.checked = '';
      // let find_index= this.options.findIndex((obj:any) => obj.id == option.id);
      // if(find_index !=-1){
      //   let current_option = this.options[find_index];

      //   current_option.card_checked=false;
      //   current_option.checked = '';
      //   if(current_option.is_critical_control){
      //     let cvpc_cat_question = current_option.cvpc_cat_question.QUESTIONS;
      //     cvpc_cat_question.forEach(element => {
      //       element.expanded=false;
      //       (element.options).map(obj => obj. defaultValue= "Not Applicable")
      //     });
      //     current_option.cvpc_cat_question.QUESTIONS=cvpc_cat_question;
      //   }

      //   this.options[find_index]=current_option;
      // }
    }
    if (option.is_critical_control) option.cvpc_category = (option?.cvpc_category).trim();
    let exisitngRelatesTo = this.bogService.selectedRelatesTo;
    let findIndex = exisitngRelatesTo.findIndex((obj) => obj.id == option.id);
    if (findIndex == -1) {
      this.bogService.selectedRelatesTo.push(option);

      if (!option.is_critical_control) this.is_relates_to_selected = true;
      else if (option.is_critical_control) {
        let array_cvpc_cat: any = [];
        if (option.is_multiple_cvpc) {
          array_cvpc_cat = option.cvpc_category_list;
        } else {
          array_cvpc_cat.push(option.cvpc_category);
        }
        array_cvpc_cat.forEach((element) => {
          let filter = this.cvpc_relates_to.filter((obj: any) => obj.cvpc == element);
          if (filter.length == 0) {
            let cvpc = this.appservice.cvpc_formatted_list.filter(
              (cvpc_obj: any) => cvpc_obj.cvpc == element
            );
            this.cvpc_relates_to.push(cvpc[0]);
          }
        });
      }
    } else {
      exisitngRelatesTo = exisitngRelatesTo.filter((obj: any) => obj.id != option.id);

      option.card_checked = false;
      option.checked = '';
      let find_index = this.options.findIndex((obj: any) => obj.id == option.id);
      if (find_index != -1) {
        let current_option = this.options[find_index];

        current_option.card_checked = false;
        current_option.checked = '';
        if (option.is_critical_control) {
          // let arracy_cvpc_cat:any=[];
          // if(option.is_multiple_cvpc){
          //   arracy_cvpc_cat=option.cvpc_category_list;
          // }
          // else{
          //   arracy_cvpc_cat.push(option.cvpc_category)
          // }

          let check_existing_vpc = exisitngRelatesTo.filter(
            (obj: any) => obj.cvpc_category == option.cvpc_category && obj.id != option.id
          );

          if (check_existing_vpc.length == 0) {
            this.cvpc_relates_to = this.cvpc_relates_to.filter(
              (obj: any) => obj.cvpc != option.cvpc_category
            );
            let filter_unwanted_cvpc = this.appservice.cvpc_formatted_list.filter(
              (obj: any) => obj.cvpc == option.cvpc_category
            );
            filter_unwanted_cvpc[0].question.forEach((element) => {
              element.expanded = false;
              element.isActive = false;
              element.cvpc_question.forEach((ele) => {
                ele.defaultValue = 'Not Applicable';
              });
            });
            let idx = this.appservice.cvpc_formatted_list.findIndex(
              (obj: any) => obj.cvpc == option.cvpc_category
            );
            this.appservice.cvpc_formatted_list[idx] = filter_unwanted_cvpc[0];
          }
          if (current_option.id == 'li_9999999_3302' && !current_option.card_checked) {
            this.cvpc_relates_to = this.cvpc_relates_to.filter(
              (obj: any) => obj.cvpc != option.cvpc_category
            );
            let filter_unwanted_cvpc = this.appservice.cvpc_formatted_list.filter(
              (obj: any) => obj.cvpc == 'Liquid Fuel Fire'
            );
            filter_unwanted_cvpc[0].question.forEach((element) => {
              element.expanded = false;
              element.isActive = false;
              element.cvpc_question.forEach((ele) => {
                ele.defaultValue = 'Not Applicable';
              });
            });
            this.cvpc_relates_to = this.cvpc_relates_to.filter(
              (obj: any) => obj.cvpc != 'Liquid Fuel Fire'
            );
            let idx = this.appservice.cvpc_formatted_list.findIndex(
              (obj: any) => obj.cvpc == 'Liquid Fuel Fire'
            );
            this.appservice.cvpc_formatted_list[idx] = filter_unwanted_cvpc[0];
          }
        }

        this.options[find_index] = current_option;
      }
    }

    this.bogService.selectedRelatesTo = exisitngRelatesTo;
    console.log('array_cvpc_cat', this.cvpc_relates_to);
    if (this.cvpc_relates_to.length == 1 && this.cvpc_relates_to[0].cvpc === 'Mental Health') {
      this.showMentalHealthText = true;
    } else {
      this.showMentalHealthText = false;
    }
    // if(option.card_checked && option.is_critical_control){
    //   let filter =(this.appservice.cvpc_formatted_list).filter((obj:any)=>obj.cvpc_category==option.cvpc_category);
    //   if(filter.length >0)
    //     this.cvpc_relates_to.push(filter[0]);
    //   // this.cvpc_relates_to.push()
    // }
    // else if(!option.card_checked && option.is_critical_control){
    //   let check_existing_vpc=exisitngRelatesTo.filter((obj:any)=>obj.cvpc_category == option.cvpc_category && obj.id!=option.id);
    //   if(check_existing_vpc.length ==0){

    //   }
    //   else{

    //   }
    // }
    // this.current_relates_to=option;
    let count = 0;
    this.cvpc_relates_to.forEach((element) => {
      count = count + element.question.length;
    });
    this.PUE_count = count;
    this.selected_sub_RelatesTo = exisitngRelatesTo;
    this.is_critical_control = option.is_critical_control;
    if (type != 'select') {
      this.is_critical_control = false;
    }
    this.bogService.relatesToSubject.next(true);
  }

  expandItem(index, relates_to) {
    let findIndex = this.cvpc_relates_to.findIndex((obj: any) => obj.cvpc == relates_to.cvpc);
    this.cvpc_relates_to[findIndex].question[index].expanded =
      !this.cvpc_relates_to[findIndex].question[index].expanded;
    let current_PUE = this.cvpc_relates_to[findIndex].question;
    let filter_expaned = current_PUE.filter((obj: any) => obj.expanded == true);
    if (filter_expaned.length > 0) this.cvpc_relates_to[findIndex].isActive = true;
    else this.cvpc_relates_to[findIndex].isActive = false;
  }
  updateFormValue(idx, i, k, data) {
    this.is_relates_to_selected = true;
    this.cvpc_relates_to[idx].question[i].cvpc_question[k].defaultValue = data;
  }
  ngOnDestroy(): void {
    if (this.subscriber_cvpc) this.subscriber_cvpc.unsubscribe();
  }
}
